<!--

会員番号のバーコードを表示します。

ゴルフ場のスキャナー機器で来場者のスマートフォンに表示されたバーコードを読み取る時に使用します。

以下のモジュールを使用してバーコードを生成します。
https://lindell.me/JsBarcode/

-->
<template>
    <div>
        <span class="btn btn-primarys col" v-on:click="toggleBarCode">{{ toggleButtonName }}</span>
        <div class="spBarcode__dispArea" v-show="isShow">
            <svg id="barcode"></svg>
        </div>
    </div>
</template>

<script>
import { memberNumberMixin } from '../../../mixins/MyPage/memberNumberMixin';
import JsBarcode from 'jsbarcode';

const showButtonName = '会員番号バーコード表示';
const hideButtonName = '会員番号バーコード非表示';

export default {
    mixins: [
        memberNumberMixin
    ],
    props: {
        golfGroupCode: {
            type: String,
            required: true,
        }
    },
    data () {
        return {
            toggleButtonName: showButtonName,
            isShow: false,
        };
    },
    mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
        },
        makeDisplayCode(memberNo) {
            const memberNumber = this.getReadableMemberNumberByScannerDevice(
                this.golfGroupCode,
                memberNo,
            );
            JsBarcode("#barcode", memberNumber, {
                format: "CODE39",
                width: 1.2,
                displayValue: false
            });
        },
        toggleBarCode() {
            this.isShow = !this.isShow;
            if (this.isShow) {
                this.toggleButtonName = hideButtonName;
            } else {
                this.toggleButtonName = showButtonName;
            }
        }
    }
}
</script>

<style scoped>
</style>
